import * as runtime from '@/api/runtime'
import {
  BatchStatisticsPageLoadRequest,
  BatchStatisticsPageLoadRequestToJSON
} from '@/api'

import {
  BatchOrderAcceptListPageLoadResult,
  BatchOrderAcceptListPageLoadResultFromJSON
} from '@/api/models/batch/BatchOrderAcceptListPageLoadResult'
import {
  BatchOrderAcceptListRequest,
  BatchOrderAcceptListRequestToJSON
} from '@/api/models/batch/BatchOrderAcceptListRequest'

export class BatchOrderAcceptListApi extends runtime.BaseAPI {
  /**
   * 画面初期表示時の検索状態取得
   * @param request
   */
  async readInitialPattern(
    request: BatchStatisticsPageLoadRequest
  ): Promise<BatchOrderAcceptListPageLoadResult> {
    const response = await this.requestGet(
      `/batch/statistics/search_initial_condition`,
      BatchStatisticsPageLoadRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchOrderAcceptListPageLoadResultFromJSON(jsonValue)
    ).value()
  }

  async createOrderList(request: BatchOrderAcceptListRequest): Promise<number> {
    const response = await this.requestPost(
      `/batch/order-accept/order_list`,
      BatchOrderAcceptListRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }
}
